import _ from 'lodash';
import React from 'react';

import AsyncSelect from 'components/AsyncSelect';
import {DetailTenantInfo} from 'components/TenantInfo';

import zoomIcon from './assets/zoom.svg';

import './styles.css';

interface UserOptionProps {
  label: string;
  value: number;
  object: {
    id: number;
    fullName: string;
    email: string;
    avatarCroppped: string;
    internalAvatarCroppped: string;
    initials: string;
  };
}

const UserOption = (option: UserOptionProps) => (
  <DetailTenantInfo tenant={option.object} />
);

interface UserFilterProps {
  userRef?: any;
  filterBy: (field, value) => void;
  fetchFunction: (search: string) => void;
  clearOption: () => void;
  buildOptions: (x: any) => void;
}

const UserFilter = ({
  userRef,
  filterBy,
  fetchFunction,
  clearOption,
  buildOptions
}: UserFilterProps) => {
  return (
    <div
      className="UserFilter inputWrapper"
      style={{backgroundImage: `url(${zoomIcon})`}}>
      <AsyncSelect
        ref={userRef}
        fetchFunction={fetchFunction}
        buildOptions={buildOptions}
        onClear={clearOption}
        optionRenderer={UserOption}
        valueRenderer={UserOption}
        arrowRenderer={null}
        creatable={false}
        filterOptions={false}
        placeholder={'Search by name or email'}
        onChange={filterBy}
      />
    </div>
  );
};

export default UserFilter;
